module.exports = __webpack_public_path__ + "static/media/screen-video-robotica.52e6f3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Educatie/video-screenshots/screen-video-robotica.jpg
// module id = 751
// module chunks = 0